import React, { memo } from "react";
import moment from "moment";
import { Div, Img, Txt } from "Components/GenericView";
import PackageTransactionItem from "./PackageTransactionItem";

const PackageDetail: React.FunctionComponent<any> = (props) => {
  const { setPackageId, packageDetail } = props;
  console.log(
    "🚀 ~ file: PackageDetail.tsx ~ line 7 ~ packageDetail",
    packageDetail
  );
  const isActive = packageDetail.isActive;
  const getExpiryDateBlockColor = (nestedPackage: any) => {
    if (moment(nestedPackage.expiry_date).diff(moment(), "days") < 7)
      return "rgb(255, 136, 136,0.2)";
    return "#EEF0F1";
  };
  const getExpiryBarColor = (nestedPackage: any) => {
    if (nestedPackage.remaining_duration <= 2) return "#FF8888";
    return Number(nestedPackage.remaining_duration) <
      nestedPackage.total_duration * 0.2
      ? "#FF8888"
      : "#32bdc7";
  };
  return (
    <Div className="package-detail">
      <div className="bg-img">
        <Div>
          <Div p="5px 12px" br={13.5} bg="#fff" className="active-tab">
            <Txt
              bg={isActive ? "#7ED321" : "#C9C9C9"}
              br={8}
              width={10}
              height={10}
              inline
            />
            <Txt ml={10} inline>
              {isActive ? "Active" : "Expired"}
            </Txt>
          </Div>
        </Div>
      </div>
      <Div textAlign="center" margin={"-30px 17.5px 17.5px 17.5px"}>
        <img
          src="/self-serve/pg_wallet@3x.png"
          alt="wallet"
          height={38}
          width={50.42}
        />
        <Txt color="#777789" fs={12} mt={8}>
          {packageDetail.mainTitle}
        </Txt>
        <Txt color="#22234E" fs={22}>
          {packageDetail.title}
        </Txt>
        <Div b h hc vc>
          <Txt color="#595968" fs={14}>
            {`${packageDetail.currency_symbol + packageDetail.rate}/${
              packageDetail.rate_desc
            }`}
          </Txt>
          <Txt color="rgb(89, 89, 104,0.6)" fs={12} ml={8}>
            {`Save up to ${packageDetail.save_amount}`}
          </Txt>
        </Div>
        <Div
          bg="#fff"
          mt={10}
          br={16}
          p="15.5px 18px"
          className="pd-slider"
          textAlign="center"
        >
          <Txt
            color={isActive ? getExpiryBarColor(packageDetail) : "#C4C4C4"}
            fs={18}
          >
            <b>{packageDetail.remaining_desc}</b>
          </Txt>
          <Div className="hv-progress-bar" margin={"8px 0px 3px 0px"}>
            <div
              style={{
                width:
                  (Number(packageDetail.remaining_duration) /
                    packageDetail.total_duration) *
                    100 +
                  "%",
                background: isActive
                  ? getExpiryBarColor(packageDetail)
                  : "#C9C9C9",
              }}
              className="hv-progress-bar-filled"
            ></div>
          </Div>
        </Div>
        <Div
          bg={getExpiryDateBlockColor(packageDetail)}
          mt={10}
          color={
            getExpiryDateBlockColor(packageDetail) === "#EEF0F1"
              ? "#4A4A4A"
              : "rgb(255, 136, 136)"
          }
          h
          vc
          p="12.5px 14px"
          br={8}
          className="justify-between"
        >
          <Div h vc>
            <Img
              src={
                getExpiryDateBlockColor(packageDetail) ===
                "rgb(255, 136, 136,0.2)"
                  ? "/self-serve/expiration-red@3x.png"
                  : "/self-serve/expiration-blue@3x.png"
              }
              size={21}
            />
            <Div fs={14} ml={10}>
              {isActive ? "Expiring on " : "Expired on "}
              <b>{moment(packageDetail.expiry_date).format("D MMM YYYY")}</b>
            </Div>
          </Div>
          {isActive && (
            <Div color="#757588" fs={12}>
              {`${moment(packageDetail.expiry_date).diff(
                moment(),
                "days"
              )} Days to go`}
            </Div>
          )}
        </Div>
        <Div mt={23} pt={23} className="wa-tr">
          <Div className="flex justify-between center">
            <Txt fs={16} color={"#22234E"}>
              Package Transactions
            </Txt>
            {packageDetail.transactions.length > 0 && (
              <Txt
                color="#32BDC7"
                fs={14}
                pointer
                onClick={() => setPackageId(packageDetail.purchased_id)}
              >
                Show all
              </Txt>
            )}
          </Div>
          {packageDetail.transactions.length === 0 && (
            <Div
              bg="#EEF0F1"
              mt={10}
              color="#757588"
              h
              vc
              p="16.5px 14px"
              br={8}
              fs={13}
              className="justify-center"
            >
              No package transactions yet
            </Div>
          )}
          <Div overflowY mt={10}>
            {packageDetail.transactions.map((item: any, index: number) => (
              <Div key={index}>
                <PackageTransactionItem item={item} />
              </Div>
            ))}
          </Div>
        </Div>
      </Div>
    </Div>
  );
};

export default memo(PackageDetail);
